import useRouteInfo from "@/app/hooks/useRouteInfo";
import { useRouter } from "@/app/hooks/useRouter";
import { ICustomerProfileState } from "@/app_redux/reducers/slices/auth/customer_profile_slice";
import { Dialog, Transition } from "@headlessui/react";
import { Fragment, useRef } from "react";
import { BsTruck } from "react-icons/bs";
import { BiRupee } from "react-icons/bi";

export interface ICheckoutProps {
  phone_number: string;
}

export default function UnifiedCartOrderConfirmModal({
  open,
  setOpen,
  activeCartDetails,
  currentAddress,
  handlePresent,
  callLogAPIBase,
}) {
  const cancelButtonRef = useRef(null);
  const { getRouteKey } = useRouter();
  const { routeState } = useRouteInfo(getRouteKey("CUSTOMER_PROFILE", "id"));
  const { customerId } = routeState.state as ICustomerProfileState;

  const handleConfirmClick = () => {
    handlePresent("CHECKOUT");
    callLogAPIBase(activeCartDetails);
    setOpen(false);
    const targetUrl = `/app/user-cart/cart-billing/${customerId}?from_cart=true`;
    window.location.href = targetUrl;
  };

  return (
    <div>
      <Transition.Root show={open} as={Fragment}>
        <Dialog as="div" className="relative z-40" initialFocus={cancelButtonRef} onClose={() => {}}>
          <Transition.Child
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0"
            enterTo="opacity-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
          >
            <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
          </Transition.Child>
          <div className="fixed inset-0 z-10 w-screen overflow-y-auto">
            <div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
              <Transition.Child
                as={Fragment}
                enter="ease-out duration-300"
                enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                enterTo="opacity-100 translate-y-0 sm:scale-100"
                leave="ease-in duration-200"
                leaveFrom="opacity-100 translate-y-0 sm:scale-100"
                leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
              >
                <Dialog.Panel
                  className={`relative transform rounded-lg bg-white px-4 pb-4 pt-5 text-left shadow-xl transition-all sm:my-4 sm:w-[500px] sm:p-6 flex flex-col `}
                >
                  <div className="pb-2 flex justify-between items-center">
                    <div className="flex gap-2 items-center">
                      <div className="flex justify-center">
                        <img
                          src="https://vetic-img.s3.ap-south-1.amazonaws.com/quick_commerce//misc/confirme_Icon.svg"
                          alt="check_icon"
                          className="w-10 h-10"
                        />
                      </div>
                      <div>
                        <div className="font-semibold text-sm mb-1">Order Confirmed</div>
                        <div className="font-medium text-sm flex items-center">
                          <BiRupee size={18} />
                          {activeCartDetails?.price_breakup?.net_total_after_tax}{" "}
                        </div>
                      </div>
                    </div>
                  </div>
                  <div>
                    <div className="mt-2   rounded-md text-sm">Order will pickup, once the payment receive</div>
                    <div className="rounded-lg bg-[#f4f4f4] p-3 mt-5">
                      <div className="flex gap-2 items-center">
                        <div className="font-medium text-sm">Delivery Address</div>
                        <div className="rounded-2xl py-1 px-3 text-[10px] font-medium bg-[#EEFFF5] text-[#00873C]">
                          {currentAddress?.label}
                        </div>
                        {currentAddress?.previously_ordered && (
                          <div className="rounded-md bg-[#dedede] text-[#666666] w-24 p-1 text-[10px] text-center">
                            Last Delivered
                          </div>
                        )}
                      </div>
                      <div className="text-[#6a717e] text-xs mt-3">{currentAddress?.address_1}</div>
                      <div className="text-[#6a717e] text-xs mt-1">{currentAddress?.address_2}</div>

                      <div className="flex gap-2 items-center mt-2">
                        <BsTruck className="w-5 h-5 text-black" />
                        <div className="text-[#6a717e] text-xs">
                          Delivered by{" "}
                          <span className="text-black font-medium">
                            {activeCartDetails?.price_breakup?.delivery_status}
                          </span>
                        </div>
                      </div>
                    </div>
                    <div className="mt-5">
                      <button
                        type="submit"
                        onClick={handleConfirmClick}
                        className="rounded-md w-full px-10 py-[9px] font-normal text-sm shadow-sm bg-black text-white cursor-pointer"
                      >
                        Done
                      </button>
                    </div>
                  </div>
                </Dialog.Panel>
              </Transition.Child>
            </div>
          </div>
        </Dialog>
      </Transition.Root>
    </div>
  );
}
